var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIconLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_720",
    "data-name": "Group 720",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.058,
    height: 31.612,
    viewBox: "0 0 32.058 31.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 32.058,
    height: 31.612,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M20.383,23.559A12.846,12.846,0,0,1,17.09,25.22a12.737,12.737,0,0,1-9.509-.5,12.733,12.733,0,0,1-5.96-5.512A12.648,12.648,0,0,1,.035,12.018a12.708,12.708,0,0,1,2.1-6.177A12.8,12.8,0,0,1,6.782,1.563,12.689,12.689,0,0,1,13.338.007a12.636,12.636,0,0,1,7.4,2.6,12.59,12.59,0,0,1,4.775,7.173,12.644,12.644,0,0,1-1.379,9.684.438.438,0,0,0,.078.651q3.492,3.46,6.959,6.944a2.59,2.59,0,0,1-3.293,4c-.161-.132-.316-.272-.464-.42q-3.4-3.4-6.8-6.8c-.08-.08-.145-.177-.232-.285m1.331-10.622A8.759,8.759,0,1,0,12.99,21.7a8.777,8.777,0,0,0,8.724-8.763",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconLarge);
export default __webpack_public_path__ + "static/media/search-icon-large.761e4c1b27848d7dbc5cb4f45c2ad946.svg";
export { ForwardRef as ReactComponent };